<!--
 * @Author: your name
 * @Date: 2021-08-09 15:14:26
 * @LastEditTime: 2021-08-23 16:12:03
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\views\layout\layout.vue
-->
<template>
  <div class="app_div">
    <top />
    <router-view/>
    <Footer-info />
  </div>
</template>

<script>
import top from '@/components/pageComponents/top.vue';
import FooterInfo from '@/components/pageComponents/footer.vue'
export default {
  components: { top,FooterInfo },
  data() {
    return {
    };
  },
  methods: {
    
  }
};
</script>
<style>
.app_div{
    width: 100%;
    height: 100vh;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/topLayout.vue